import { render, staticRenderFns } from "./ThreadPostNotification.vue?vue&type=template&id=4591bc4c&scoped=true&"
import script from "./ThreadPostNotification.vue?vue&type=script&lang=js&"
export * from "./ThreadPostNotification.vue?vue&type=script&lang=js&"
import style0 from "./ThreadPostNotification.vue?vue&type=style&index=0&id=4591bc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4591bc4c",
  null
  
)

export default component.exports